export const getScoreColorClass = (score) => {
  if (score >= 75) {
    return 'score-green'; // 75-100%
  } else if (score >= 25) {
    return 'score-yellow';
  } else {
    return 'score-red'; // 0-24%
  }
};

export const getScoreColor = (score) => {
  if (score >= 75) {
    return '#44D7A8';
  } else if (score >= 25) {
    return '#ff8d63';
  } else {
    return '#FF0038';
  }
};
